/**

 * @作者 王

 * @创建于 2021/5/19 9:59

 */

import store from '../store'
import {getEnumListByCodeApi} from "../server/system";

const $workBook = async (code)=>{
    if (store.state.dictionaries[code]) {
        return JSON.parse(JSON.stringify(store.state.dictionaries[code]));
    } else {
        await getEnumListByCodeApi(code).then(res => {
            if (res[0] &&  res[0].childList){
                let json = {code: code, list: res[0].childList};
                store.commit('setDictionary', json);
            }else{
                let json = {code: code, list: res};
                store.commit('setDictionary', json);
            }
        });
        return JSON.parse(JSON.stringify(store.state.dictionaries[code]));
    }
};

const install = (Vue)=>{
    Vue.prototype.$workBook = $workBook
}
export default {
    install
}
